import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bsngx-model',
  templateUrl: './bsngx-model.component.html',
  styleUrls: ['./bsngx-model.component.scss']
})
export class BsngxModelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
